import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type IcHubLocaleCurrencyDTO = z.infer<typeof IcHubLocaleCurrencyDTORuntype>;
export const IcHubLocaleCurrencyDTORuntype = z.enum(['CNY', 'CNYNoTax', 'USD']);

export interface IcHubCredentialsDTO extends z.infer<typeof IcHubCredentialsDTORuntype> {}
export const IcHubCredentialsDTORuntype = z.object({
    api_key: z.string(),
    username: z.string(),
    password: z.string(),
    currency: IcHubLocaleCurrencyDTORuntype,
});

export interface IcHubCredentialsInputDTO extends z.infer<typeof IcHubCredentialsInputDTORuntype> {}
export const IcHubCredentialsInputDTORuntype = z.object({
    api_key: z.string().optional(),
    username: z.string().optional(),
    password: z.string().optional(),
    currency: IcHubLocaleCurrencyDTORuntype.optional(),
});

export interface IcHubResponseBodyDTO extends z.infer<typeof IcHubResponseBodyDTORuntype> {}
export const IcHubResponseBodyDTORuntype = z.object({
    data: IcHubCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
